import { AxiosInstance } from 'axios';
import {
  IngestResponse,
  ItemsListResponse,
  ListFeedsFilters,
  ListItemsFilters,
  ListPriceHistoryFilters,
  ListRunsFilters,
  PriceHistoryResponse,
  RunReport,
  RunsListResponse,
  SupplierPriceListDetail,
  SupplierPriceListsListResponse,
} from './supplier-price-lists.types';

const BASE = '/v1/supplier-price-lists';

export const createSupplierPriceListsApi = (api: AxiosInstance) => ({
  list: (filters?: ListFeedsFilters) =>
    api
      .get<SupplierPriceListsListResponse>(BASE, { params: filters })
      .then((r) => r.data),

  get: (id: string) =>
    api.get<SupplierPriceListDetail>(`${BASE}/${id}`).then((r) => r.data),

  ingest: (id: string) =>
    api.post<IngestResponse>(`${BASE}/${id}/ingest`).then((r) => r.data),

  runs: (id: string, filters?: ListRunsFilters) =>
    api
      .get<RunsListResponse>(`${BASE}/${id}/runs`, { params: filters })
      .then((r) => r.data),

  confirmMissing: (id: string, runId: string) =>
    api
      .post<RunReport>(`${BASE}/${id}/runs/${runId}/confirm-missing`)
      .then((r) => r.data),

  items: (id: string, filters?: ListItemsFilters) =>
    api
      .get<ItemsListResponse>(`${BASE}/${id}/items`, { params: filters })
      .then((r) => r.data),

  priceHistory: (id: string, itemId: string, filters?: ListPriceHistoryFilters) =>
    api
      .get<PriceHistoryResponse>(
        `${BASE}/${id}/items/${itemId}/price-history`,
        { params: filters },
      )
      .then((r) => r.data),
});
